import { CountryRegion } from "./Regions";

import AndeanLab from '../data/andean-lab.json';
import AndeanNoLab from '../data/andean-no-lab.json';
import CaribbeanLab from '../data/caribbean-lab.json';
import CaribbeanNoLab from '../data/caribbean-no-lab.json';
import CentralLab from '../data/central-lab.json';
import CentralNoLab from '../data/central-no-lab.json';
import NorthLab from '../data/north-lab.json';
import NorthNoLab from '../data/north-no-lab.json';
import SouthLab from '../data/south-lab.json';
import SouthNoLab from '../data/south-no-lab.json';
import TropicalLab from '../data/tropical-lab.json';
import TropicalNoLab from '../data/tropical-no-lab.json';
import { CholesterolUnit, Gender } from "./Settings";

function GetLookupTable(region: CountryRegion, hasCholesterol: boolean) {
  var selectedTable;

  switch (region) {
    case CountryRegion.Andean:
      selectedTable = hasCholesterol ? AndeanLab : AndeanNoLab;
      break;
    case CountryRegion.Caribbean:
      selectedTable = hasCholesterol ? CaribbeanLab : CaribbeanNoLab;
      break;
    case CountryRegion.Central:
      selectedTable = hasCholesterol ? CentralLab : CentralNoLab;
      break;
    case CountryRegion.North:
      selectedTable = hasCholesterol ? NorthLab : NorthNoLab;
      break;
    case CountryRegion.South:
      selectedTable = hasCholesterol ? SouthLab : SouthNoLab;
      break;
    case CountryRegion.Tropical:
      selectedTable = hasCholesterol ? TropicalLab : TropicalNoLab;
      break;
  }

  if (selectedTable)
    selectedTable = selectedTable as { [key: string]: number };

  return selectedTable;
}

export function ComputeRisk(
  region: CountryRegion,
  gender: string,
  age: number,
  isSmoker: boolean,
  isDiabetes: boolean,
  systolicPressure: number,
  hasCholesterol: boolean,
  cholesterol: number,
  cholesterolUnit: CholesterolUnit,
  bmi: number) {
  let score: string = '';

  score += (gender === Gender.Male) ? '1' : '0';
  score += isSmoker ? '1' : '0';

  // Age
  if (age < 45)
    score += '1';
  else if (age < 50)
    score += '2';
  else if (age < 55)
    score += '3';
  else if (age < 60)
    score += '4';
  else if (age < 65)
    score += '5';
  else if (age < 70)
    score += '6';
  else
    score += '7';

  // Systolic Pressure
  if (systolicPressure < 120)
    score += '1';
  else if (systolicPressure < 140)
    score += '2';
  else if (systolicPressure < 160)
    score += '3';
  else if (systolicPressure < 180)
    score += '4';
  else
    score += '5';

  if (hasCholesterol && cholesterol > 0) {
    // Cholesterol
    score = (isDiabetes ? '1' : '0') + score;

    let mgdl = cholesterolUnit === CholesterolUnit.mgdl;
    if (mgdl) {
      if (cholesterol < 155)
        score += '1';
      else if (cholesterol < 193)
        score += '2';
      else if (cholesterol < 232)
        score += '3';
      else if (cholesterol < 270)
        score += '4';
      else
        score += '5';
    }
    else {
      if (cholesterol < 4)
        score += '1';
      else if (cholesterol < 5)
        score += '2';
      else if (cholesterol < 6)
        score += '3';
      else if (cholesterol < 7)
        score += '4';
      else
        score += '5';
    }
  }
  else {
    // BMI based
    if (bmi < 20)
      score += '1';
    else if (bmi < 25)
      score += '2';
    else if (bmi < 30)
      score += '3';
    else if (bmi < 35)
      score += '4';
    else
      score += '5';
  }

  // Trim score value
  score = parseInt(score).toString();

  const table = GetLookupTable(region, hasCholesterol);
  const riskValue = table[score] || 0;

  // Compute assesment
  let assesment: string = '';
  if (riskValue >= 30)
    assesment = "Critical";
  else if (riskValue >= 20)
    assesment = "Very high";
  else if (riskValue >= 10)
    assesment = "High";
  else if (riskValue >= 5)
    assesment = "Moderate";
  else
    assesment = "Low";

  return [riskValue, assesment];
}

export function isValid(field: number, min: number, max: number) {
  return field >= min && field <= max;
}